import React from "react";
import { Popup, Button } from "react-vant";
import styles from "./systemBrowserPopup.module.css";
import Image from "next/image";
import { toast } from "@/components/common/Toast";
import { useTranslation } from "next-i18next";
interface SystemBrowserPopupProps {
  show: boolean;
  onClose: () => void;
}

const SystemBrowserPopup: React.FC<SystemBrowserPopupProps> = ({
  show,
  onClose,
}) => {
  const { t } = useTranslation("common");
  const handleCopy = () => {
    const url = window.location.href;
    if (
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === "function"
    ) {
      navigator.clipboard
        .writeText(url)
        .then(() => toast.info(t("sysBroPupup.copySuc")))
        .catch(() => toast.error(t("sysBroPupup.copyFail")));
    } else {
      // 兼容老浏览器/环境
      try {
        const input = document.createElement("input");
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        toast.info(t("sysBroPupup.copySuc"));
      } catch (e) {
        toast.error(t("sysBroPupup.copyFail"));
      }
    }
  };

  return (
    <Popup
      visible={show}
      onClose={onClose}
      closeable
      position="bottom"
      className={styles.customPopup}
      style={{ padding: 24, textAlign: "center" }}
    >
      <div className="px-[40px] absolute left-1/2 top-1/2 px-[40px] flex flex-col items-center justify-center text-center -translate-x-1/2 -translate-y-1/2 w-full flex flex-col items-center justify-center text-center">
        <Image
          src="https://pgc.otv.cc/iconImg/20250617/1750165121608_status_defalt.png"
          alt="award"
          width={200}
          height={200}
        />
        <span className="text-[#999999] mt-[24px] leading-[120%]">
          {t("sysBroPupup.tips")}
        </span>
        <div
          className="mt-[16px] h-[43px] w-full flex items-center justify-center bg-main rounded"
          onClick={handleCopy}
        >
          {t("sysBroPupup.copyTips")}
        </div>
      </div>
    </Popup>
  );
};

export default SystemBrowserPopup;
